import {useEffect, useState} from "react";
import {findBookingsWithPagination} from "../api/eventGroupApiClient";

export const useBookings = (eventId, status, page, pageSize, reloadTrigger) => {
    const [bookings, setBookings] = useState([]);
    const [pagination, setPagination] = useState(null);

    useEffect(() => {
        const abortController = new AbortController();
        const bookingsWithPagination = findBookingsWithPagination(eventId, status, page, pageSize, abortController.signal);

        bookingsWithPagination
            .then(
                (data) => {
                    const bookings = data.bookings;
                    const pagination = data.pagination;

                    setBookings(bookings)
                    setPagination(pagination)
                }
            )
            .catch(
                (error) => console.log(error)
            );

        return () => {
            abortController.abort();
        };
    }, [eventId, status, page, pageSize, reloadTrigger]);

    return {bookings : bookings, pagination};
};